import { render } from "./DetailModal.vue?vue&type=template&id=536ddd82&scoped=true"
import script from "./DetailModal.vue?vue&type=script&lang=js"
export * from "./DetailModal.vue?vue&type=script&lang=js"

import "./DetailModal.vue?vue&type=style&index=0&id=536ddd82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536ddd82"]])

export default __exports__